import React from 'react';

const ShieldImage = ({
  ariaDescribedByContent,
}: {
  ariaDescribedByContent?: React.ReactNode;
}): React.ReactElement => (
  <svg
    aria-describedby="secure-payment-shield-icon"
    width="90"
    height="90"
    role="img"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="secure-payment-shield-icon">{ariaDescribedByContent}</title>
    <path
      d="M44.8578 83.6642C64.4727 83.6642 80.3737 81.7511 80.3737 79.3912C80.3737 77.0313 64.4727 75.1182 44.8578 75.1182C25.2428 75.1182 9.3418 77.0313 9.3418 79.3912C9.3418 81.7511 25.2428 83.6642 44.8578 83.6642Z"
      fill="#DBD8D0"
    />
    <path
      d="M77.0905 18.2016C57.888 16.5456 47.1529 8.78913 46.986 8.63929C45.643 7.65979 43.7168 7.65979 42.3737 8.63929C42.2885 8.71576 31.5573 16.5458 12.2692 18.2016C10.425 18.3516 9 19.7841 9 21.4401C9 65.2639 41.8727 78.5911 43.2976 79.1212C43.802 79.2712 44.2214 79.4212 44.7225 79.4212C45.227 79.4212 45.7282 79.3448 46.1474 79.1212C47.5724 78.5947 80.445 65.2676 80.445 21.4401C80.3631 19.7841 78.9348 18.3516 77.0905 18.2016Z"
      fill="#D89700"
    />
    <mask
      id="mask0_370_58574"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="10"
      y="6"
      width="70"
      height="70"
    >
      <path
        d="M76.0454 16.7148C57.4623 15.1122 47.0735 7.60594 46.912 7.46093C45.6123 6.51302 43.7483 6.51302 42.4485 7.46093C42.366 7.53493 31.981 15.1124 13.3151 16.7148C11.5304 16.8599 10.1514 18.2462 10.1514 19.8488C10.1514 62.2589 41.9636 75.1562 43.3426 75.6691C43.8307 75.8143 44.2366 75.9596 44.7215 75.9596C45.2098 75.9596 45.6947 75.8856 46.1004 75.6691C47.4795 75.1597 79.2917 62.2624 79.2917 19.8488C79.2124 18.2462 77.8302 16.8599 76.0454 16.7148Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_370_58574)">
      <path
        d="M76.0464 16.7148C57.4632 15.1122 47.0745 7.60594 46.913 7.46093C45.6133 6.51302 43.7493 6.51302 42.4494 7.46093C42.367 7.53493 31.982 15.1124 13.3161 16.7148C11.5313 16.8599 10.1523 18.2462 10.1523 19.8488C10.1523 62.2589 41.9646 75.1562 43.3436 75.6691C43.8317 75.8143 44.2375 75.9596 44.7225 75.9596C45.2108 75.9596 45.6957 75.8856 46.1014 75.6691C47.4805 75.1597 79.2926 62.2624 79.2926 19.8488C79.2134 18.2462 77.8312 16.8599 76.0464 16.7148Z"
        fill="#F9B822"
      />
      <path
        d="M61.4832 69.6606C86.9399 69.6606 107.577 49.3593 107.577 24.3164C107.577 -0.72654 86.9399 -21.0278 61.4832 -21.0278C36.0264 -21.0278 15.3896 -0.72654 15.3896 24.3164C15.3896 49.3593 36.0264 69.6606 61.4832 69.6606Z"
        fill="#FED13C"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.8991 34.4008V37.9796H42.2833V34.4008C42.2833 32.9184 43.5404 31.7167 45.0912 31.7167C46.642 31.7167 47.8991 32.9184 47.8991 34.4008ZM39.4754 50.5053H45.0912H50.707C51.7409 50.5053 52.5789 49.7042 52.5789 48.7159V39.769C52.5789 38.7807 51.7409 37.9796 50.707 37.9796V34.4008C50.707 31.436 48.1927 29.0326 45.0912 29.0326C41.9897 29.0326 39.4754 31.436 39.4754 34.4008V37.9796C38.4416 37.9796 37.6035 38.7807 37.6035 39.769V48.7159C37.6035 49.7042 38.4416 50.5053 39.4754 50.5053ZM45.0912 46.0318C46.1251 46.0318 46.9631 45.2307 46.9631 44.2424C46.9631 43.2542 46.1251 42.4531 45.0912 42.4531C44.0574 42.4531 43.2193 43.2542 43.2193 44.2424C43.2193 45.2307 44.0574 46.0318 45.0912 46.0318Z"
      fill="#D89700"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.0895 33.996V37.5748H41.4738V33.996C41.4738 32.5136 42.7308 31.3119 44.2816 31.3119C45.8324 31.3119 47.0895 32.5136 47.0895 33.996ZM38.6659 50.1005H44.2816H49.8974C50.9313 50.1005 51.7693 49.2994 51.7693 48.3111V39.3642C51.7693 38.3759 50.9313 37.5748 49.8974 37.5748V33.996C49.8974 31.0312 47.3831 28.6278 44.2816 28.6278C41.1801 28.6278 38.6659 31.0312 38.6659 33.996V37.5748C37.632 37.5748 36.7939 38.3759 36.7939 39.3642V48.3111C36.7939 49.2994 37.632 50.1005 38.6659 50.1005ZM44.2816 45.6271C45.3155 45.6271 46.1536 44.8259 46.1536 43.8377C46.1536 42.8494 45.3155 42.0483 44.2816 42.0483C43.2478 42.0483 42.4097 42.8494 42.4097 43.8377C42.4097 44.8259 43.2478 45.6271 44.2816 45.6271Z"
      fill="#142C8E"
    />
  </svg>
);

export { ShieldImage };
